import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import { Button, CreditCardIcon } from "components";
import { CreditCardTypes } from "types/enums";
import PaymentTypes from "types/enums/paymentTypes";
import { PaymentMethodValues } from "types/paymentMethod";

type DeletePaymentMethodModalProps = {
	show: boolean;
	onHide: () => void;
	handleSubmit: Function;
	paymentMethod: any;
};

const DeletePaymentMethodModal = ({
	show,
	onHide,
	handleSubmit,
	paymentMethod,
}: DeletePaymentMethodModalProps) => {
	const [isDeleting, setIsDeleting] = useState(false);

	const handleOk = async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
		try {
			setIsDeleting(true);
			e.persist();
			await handleSubmit();
		} finally {
			if (!e.isDefaultPrevented()) onHide();
			setIsDeleting(false);
		}
	};

	const closeModal = () => {
		onHide();
	};

	const {
		bankAccountName,
		paymentType,
		accountNumber,
		cardNumber,
		cardType,
	}: PaymentMethodValues = paymentMethod;

	const paymentMethodType = PaymentTypes.getByValue(paymentType?.value);

	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header closeButton>
				<Modal.Title
					className="text-center"
					style={{ marginBottom: "-30px" }}
				>
					<h6 className="font-weight-bold">Remove Payment Method</h6>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="text-center">
				<h6 className="pb-3">
					This payment method is currently in use. Are you sure you
					want to delete it?
				</h6>
				{paymentMethodType?.displayName ===
				PaymentTypes.ach.displayName ? (
					<div className="pb-4 text-muted">
						{bankAccountName} {accountNumber}
					</div>
				) : (
					<div className="pb-4 text-muted d-flex align-items-center text-center justify-content-center">
						{CreditCardTypes.getByValue(cardType)?.displayName ||
							""}
						{"  "}
						{cardNumber}
						<div className="ml-2">
							<CreditCardIcon
								name={
									CreditCardTypes.getByValue(cardType)?.name
								}
							/>
						</div>
					</div>
				)}

				<div className="pb-3">
					<Button
						onClick={closeModal}
						value="Cancel"
						variant="outline-primary"
						style={{ marginRight: "30px" }}
					/>
					<Button
						disabled={isDeleting}
						onClick={e => handleOk(e)}
						value="Yes"
					/>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default DeletePaymentMethodModal;
